export default __webpack_public_path__ + "static/media/Default Banner.2d964b0c.png";